import { CardType } from '@root/types/generated'

// получение типа карты
export const getCardType = (cardNumber: string): CardType => {
  const cleanNumber = cardNumber.replace(/\D/g, '')

  const cardPatterns: Record<string, RegExp> = {
    [CardType.MIR]: /^220[0-4]/,
    // [CardType.MAESTRO]: /^(5018|5020|5038|5893|6304|6759|6761|6762|6763)[0-9]{8,15}$/,
    [CardType.VISA]: /^4[0-9]{12}(?:[0-9]{3})?$/,
    [CardType.MASTERCARD]: /^5[1-5][0-9]{14}$/,
  }

  let result = CardType.UNKNOWN

  ;(Object.keys(cardPatterns) as unknown as CardType[]).forEach((type) => {
    if (cardPatterns[type]?.test(cleanNumber)) {
      result = type
    }
  })

  return Number(result)
}
